export default __webpack_public_path__ + "static/media/tqxy.f0eaa625.png";